import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLinkIcon } from 'lucide-react';
export function Navigation() {
  return <motion.header className="fixed top-0 left-0 right-0 z-40 py-4 md:py-5 px-4 md:px-6 bg-[#09090B]/80 backdrop-blur-md border-b border-white/[0.06]" initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-87">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-88">
        {/* Left: Logo + site */}
        <div className="flex items-center gap-3" data-id="element-89">
          <a href="#" data-id="element-90">
            <img src="https://cdn.magicpatterns.com/uploads/iGVHPVKogVYsnUchuAbdfH/AVY_LOGO.svg" alt="AVY" className="h-7 w-7" data-id="element-91" />
          </a>
          <a href="https://avy.me" target="_blank" rel="noopener noreferrer" className="text-[11px] text-zinc-400 hover:text-white transition-colors uppercase tracking-[0.15em] font-bold hidden sm:block" data-id="element-92">
            avy.me
          </a>
        </div>

        {/* Right: VIEW PROFILE + Confidential */}
        <div className="flex items-center gap-4 md:gap-6" data-id="element-93">
          <a href="https://docs.google.com/presentation/d/1D-Sn26ZSmvYawJdjVDsMMpZthnAsEGPXzPOfJiPmFYM/edit?usp=sharing" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.15em] text-accent hover:text-white transition-colors" data-id="element-94">
            <span className="hidden sm:inline" data-id="element-95">VIEW PROFILE</span>
            <span className="sm:hidden" data-id="element-96">VIEW PROFILE</span>
            <ExternalLinkIcon className="w-3 h-3" data-id="element-97" />
          </a>
          <span className="text-[10px] uppercase tracking-[0.15em] text-zinc-600 font-bold hidden md:block" data-id="element-98">
            Confidential
          </span>
        </div>
      </div>
    </motion.header>;
}